module.exports = __webpack_public_path__ + "img/aftaa_no.f8deddc0.png";